/**
 * show
 */
__.show = function(obj) {
  if (obj && obj.style.display === 'none') {
    obj.style.display = 'block';
  }
};
